import { Card, Typography } from '@mui/material';
import styled from 'styled-components';

import Button from '../../components/Button';

interface MobileRenderable {
  $isMobile: boolean;
}

const GroupsListContainer = styled(Card)`
  && {
    display: flex;
    padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(1)}`};
    flex-direction: column;
    row-gap: ${({ theme }) => theme.spacing(0.5)};
  }
`;

interface Selectable {
  selected?: boolean;
}

const GroupListEntry = styled.div<Selectable>`
  display: flex;
  width: 100%;
  padding: ${({ theme }) => theme.spacing(1)};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  color: ${({ theme, selected }) => (selected ? theme.palette.darkPrimary.main : 'inherit')};
  background-color: ${({ theme, selected }) => (selected && theme.palette.primary.light)}80;
  cursor: pointer;
  :hover {
    background-color: ${({ theme, selected }) => (selected ? `${theme.palette.primary.light}80` : theme.palette.action.hover)};
  }
`;

const GroupListEntryText = styled(Typography)<Selectable>`
  && {
    font-weight: ${({ selected }) => (selected ? 'bold' : 'inherit')};
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

const SideColumn = styled.div<MobileRenderable>`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme, $isMobile }) => ($isMobile ? 0 : theme.spacing(2))};
  position: sticky;
  top: 0;
  padding-top: ${({ theme, $isMobile }) => ($isMobile ? 0 : theme.spacing(8))};
`;

const StickyWrapper = styled.div<MobileRenderable>`
  position: relative;
  width: ${({ $isMobile }) => ($isMobile ? '100%' : '25%')};
`;

const PageContainer = styled.div<MobileRenderable>`
  display: flex;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
`;

const MainContainer = styled.div<MobileRenderable>`
  width: ${({ $isMobile }) => ($isMobile ? '100%' : '75%')};
  margin-left: ${({ theme, $isMobile }) => ($isMobile ? 0 : theme.spacing(4))};
`;

const GroupsListLoading = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(2)};
`;

const HighlightText = styled.span`
  font-weight: bold;
  color: ${({ theme }) => theme.palette.darkPrimary.main};
`;

const AddGroupButton = styled(Button)<MobileRenderable>`
  && {
    margin-left: ${({ theme, $isMobile }) => ($isMobile ? theme.spacing(2) : 0)};
    margin-right: ${({ theme, $isMobile }) => ($isMobile ? theme.spacing(2) : 0)};
  }
`;

export { GroupsListContainer,
  AddGroupButton,
  PageContainer,
  MainContainer,
  GroupListEntry,
  StickyWrapper,
  HighlightText,
  SideColumn,
  GroupsListLoading,
  GroupListEntryText };
